<template>
  <AppLayout>
    <template #subheader>
      <button class="btn btn-sm btn-outline-secondary d-lg-none mb-2" type="button" @click="isFilterOpen = true">
        Filtry
      </button>
      <div v-if="isFilterOpen" class="offcanvas-backdrop fade show" @click="isFilterOpen = false">
      </div>
      <div class="mobile-filter-panel" :class="{ show: isFilterOpen }">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h5 class="mb-0">Filtry</h5>
          <button class="btn-close" @click="isFilterOpen = false">
          </button>
        </div>
        <div class="d-flex flex-column gap-3">
          <div>
            <label class="mb-1">Projekt:</label>
            <select class="form-select form-select-sm" v-model="selectedProjectId" @change="updateSelectedProject">
              <option value="0">Wszystkie projekty</option>
              <option v-for="project in projects" :key="project.id" :value="project.id">
                {{ truncateLabel(project.label) }}
              </option>
            </select>
          </div>
          <div>
            <label class="mb-1">Zespół:</label>
            <select class="form-select form-select-sm" v-model="selectedTeamName" @change="updateSelectedTeam"
              :disabled="!selectedProjectId || (teams && teams.length === 0)">
              <option value="">Wszystkie</option>
              <option v-for="team in teams" :key="team.name" :value="team.name">
                {{ team.name }}
              </option>
            </select>
          </div>
          <Link class="btn btn-sm btn-outline-primary" :href="route('orderPaymentMethods.index')">
          Formy płatności
          </Link>
        </div>
      </div>
      <div class="d-none d-lg-flex align-items-start justify-content-between flex-nowrap gap-3">
        <div class="d-flex align-items-center gap-3 flex-nowrap">
          <div class="d-flex align-items-center gap-2">
            <label class="mb-0">Projekt:</label>
            <select class="form-select form-select-sm" v-model="selectedProjectId" @change="updateSelectedProject"
              style="min-width: 260px; max-width: 500px;">
              <option value="0">Wszystkie</option>
              <option v-for="project in projects" :key="project.id" :value="project.id">
                {{ truncateLabel(project.label) }}
              </option>
            </select>
          </div>
          <div class="d-flex align-items-center gap-2">
            <label class="mb-0">Zespół:</label>
            <select class="form-select form-select-sm" v-model="selectedTeamName" @change="updateSelectedTeam"
              :disabled="!selectedProjectId || (teams && teams.length === 0)" style="width: 180px;">
              <option value="">Wszystkie</option>
              <option v-for="team in teams" :key="team.name" :value="team.name">
                {{ team.name }}
              </option>
            </select>
          </div>
          <Link class="btn btn-sm btn-outline-primary" :href="route('orderPaymentMethods.index')">
          Formy płatności
          </Link>
        </div>
      </div>
    </template>

    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing pt-2">
      <div class="widget widget-six">
        <div class="widget-heading d-block">
          <ul style="list-style-type: none; padding: 0" v-for="error in $page.props.flash.errors">
            <li class="alert alert-danger">{{ error }}</li>
          </ul>
        </div>

        <div class="widget-content">
          <div>

            <ejs-grid ref="orderListGrid" id="orderListGridId" :height="selectedOrder?.id ? '40vh' : gridHeight"
              :dataSource="orderListDataManager" :rowHeight="32" :allowTextWrap='false' :allowExcelExport='true'
              :allowPaging="true" :allowSorting='true' :allowFiltering='true' :allowReordering='true'
              :allowResizing='true' :showColumnChooser='true' :allowSelection='true' :showCheckbox="true"
              :enablePersistence='true' :pageSettings="pageSettings" :editSettings="editSettings"
              :filterSettings="filterOptions" :toolbar="toolbar" :contextMenuItems="contextMenuItems"
              :selectionSettings="selectionOptions" :rowSelecting="rowSelecting" :toolbarClick="clickToolbarHandler"
              :contextMenuClick="clickContextMenuHandler" :actionBegin="actionBeginHandler"
              :actionComplete="actionCompleteHandler" :cellEdit="cellEdit" :recordClick="onRowClick"
              @contextMenuOpen="onContextMenuOpen" :rowDataBound="rowDataBound" :headerCellInfo="headerCellInfoEvent"
              :dataBound="dataBoundHandler" @queryCellInfo="queryCellInfo" :actionFailure="onGridActionFailure"
              :keyPressed="onKeyDown">

              <e-columns v-if="userID === 7">
                <e-column type="number" width="70" :template="'indexTemplate'" :allowEditing="false"
                  :allowSorting="false" :allowFiltering="false" />
                <e-column type="checkbox" width="40"></e-column>
                <e-column field="id" headerText="ID" :allowEditing="false" isPrimaryKey="true" :visible="false"
                  :filter="filterDefault" headerTextAlign="Left" />
                <e-column type="string" field="order_number" headerText="Numer zamówienia" :allowEditing="false"
                  :filter="filterDefault" width="200" headerTextAlign="Left" />
                <e-column field="project" headerText="Projekt" :allowEditing="false" :visible="true"
                  headerTextAlign="Left" />
                <e-column field="supplier" headerText="Wybrany dostawca" :allowEditing="false" :filter="filterDefault"
                  headerTextAlign="Left" />
                <e-column field="negotiation_name" headerText="Negocjacje" :allowEditing="false"
                  :filter="filterNegotiations" headerTextAlign="Left" />
                <e-column field="delivery_date_deadline" headerText="Termin dostawy" :allowEditing="false"
                  :filter="filterDefault" format="dd.MM.yyyy" type="date" editType="datepickeredit"
                  headerTextAlign="Left" />
                <e-column field="value_netto" headerText="Wartość netto" :allowEditing="false" :filter="filterNumeric"
                  editType="numericedit" format="N2" type="number" textAlign="Right" headerTextAlign="Left" />
                <e-column field="value_brutto" headerText="Wartość brutto" :allowEditing="false" :filter="filterNumeric"
                  editType="numericedit" format="N2" type="number" textAlign="Right" headerTextAlign="Left" />
                <e-column field="kwota_rabat" headerText="Wartość rabatu" :allowEditing="false" :filter="filterNumeric"
                  editType="numericedit" format="N2" type="number" textAlign="Right" headerTextAlign="Left" />
                <e-column field="value_netto_po_rabacie" headerText="Wartość netto po rabacie" :allowEditing="false"
                  :filter="filterNumeric" editType="numericedit" format="N2" type="number" textAlign="Right"
                  headerTextAlign="Left" />
                <e-column field="value_brutto_po_rabacie" headerText="Wartość brutto po rabacie" :allowEditing="false"
                  :filter="filterNumeric" editType="numericedit" format="N2" type="number" textAlign="Right"
                  headerTextAlign="Left" />
                <e-column field="currency" headerText="Waluta" :allowEditing="false" :filter="filterDefault"
                  textAlign="Right" headerTextAlign="Left" />
                <e-column field="required_project_created_by_names" headerText="Zlecone przez" :allowEditing="false"
                  :filter="filterDefault" headerTextAlign="Left" />
                <e-column field="required_project_release_by_names" headerText="Zwolnione przez" :allowEditing="false"
                  :filter="filterDefault" headerTextAlign="Left" />
                <e-column field="created_by_name" headerText="Utworzone przez" :allowEditing="false"
                  :filter="filterDefault" headerTextAlign="Left" />
                <e-column field="comment" headerText="Komentarz do zamówienia" :allowEditing="false"
                  :allowFiltering="false" :allowSorting="false" headerTextAlign="Left" />
                <e-column field="created_at" headerText="Data utworzenia" :allowEditing="false" type="date"
                  format="dd.MM.yyyy" :filter="filterDefault" headerTextAlign="Left" />
                <e-column field="euro_rate" headerText="Kurs Euro" :allowEditing="false" format="N4"
                  :filter="filterNumeric" type="number" textAlign="Right" headerTextAlign="Left" :visible="false" />
                <e-column field="advance" headerText="Zaliczka" :allowEditing="false" editType="numericedit" format="N2"
                  :filter="filterNumeric" type="number" textAlign="Right" :visible="false" headerTextAlign="Left" />
                <e-column field="status" headerText="Status" :allowEditing="false" editType="dropdownedit" type="string"
                  :dataSource="order_list_statuses" :edit="orderItemStatusesParams" :filter="filterStatuses"
                  :template="'statusWithColorTemplateIndex'" :visible="false" headerTextAlign="Left" />
                <e-column field="payment_method" headerText="Forma płatności" :allowEditing="false" type="string"
                  :filter="filterPaymentMethods" editType="dropdownedit" :edit="orderPaymentMethodsParams"
                  :dataSource="order_payment_methods" :visible="false" headerTextAlign="Left" />
                <e-column field="quote_requests" headerText="Zapytanie ofertowe" :allowEditing="false"
                  :filter="filterDefault" type="string" :visible="false" headerTextAlign="Left" />
                <e-column field="was_edited_later" width="80" headerTooltip="Wartość została zmieniona!" headerText="!"
                  :allowEditing="false" :allowFiltering="false" type="number" :edit="wasEditedLaterEdit"
                  editType="dropdownedit" :template="'wasEditedLaterTemplate'" :visible="false"
                  headerTextAlign="Left" />
                <e-column field="team_name" headerText="Zespół" :allowEditing="false" :visible="false"
                  headerTextAlign="Left" />
                <e-column field="send_to_mails" headerText="Maile" :allowEditing="false" :filter="filterDefault"
                  :visible="false" headerTextAlign="Left" />
                <e-column field="send_to_mails_dw" headerText="Maile DW" :allowEditing="false" :filter="filterDefault"
                  :visible="false" headerTextAlign="Left" />
                <e-column field="order_links" headerText="Linki" width="200" :allowSorting="false"
                  :template="'linksOrderListTemplate'" :allowEditing="false" :allowFiltering="false" :visible="true"
                  headerTextAlign="Left" />
                <e-column field="order_files" headerText="Załączniki" width="200" :allowSorting="false"
                  :template="'attachmentsOrderListTemplate'" :allowEditing="false" :allowFiltering="false"
                  :visible="true" headerTextAlign="Left" />
              </e-columns>
              <e-columns v-else>
                <e-column type="number" headerText="L.p." width="70" :template="'indexTemplate'" :allowEditing="false"
                  :allowSorting="false" :allowFiltering="false" />
                <e-column type="checkbox" width="40"></e-column>
                <e-column field="id" headerText="ID" :allowEditing="false" isPrimaryKey="true" :visible="false"
                  :filter="filterDefault" headerTextAlign="Left" />
                <e-column type="string" field="order_number" headerText="Numer zamówienia" :allowEditing="false"
                  :filter="filterDefault" width="200" headerTextAlign="Left" />
                <e-column field="quote_requests" headerText="Zapytanie ofertowe" :allowEditing="false"
                  :filter="filterDefault" type="string" headerTextAlign="Left" />
                <e-column field="was_edited_later" width="80" headerTooltip="Wartość została zmieniona!" headerText="!"
                  :allowEditing="true" :allowFiltering="false" type="number" :edit="wasEditedLaterEdit"
                  editType="dropdownedit" :template="'wasEditedLaterTemplate'" headerTextAlign="Left" />
                <e-column field="project" headerText="Projekt" :allowEditing="false" :visible="true"
                  headerTextAlign="Left" />
                <e-column field="team_name" headerText="Zespół" :allowEditing="false" :visible="true"
                  headerTextAlign="Left" />
                <e-column field="supplier" headerText="Wybrany dostawca" :allowEditing="false" :filter="filterDefault"
                  headerTextAlign="Left" />
                <e-column field="negotiation_name" headerText="Negocjacje" :allowEditing="false"
                  :filter="filterNegotiations" headerTextAlign="Left" />
                <e-column field="send_to_mails" headerText="Maile" :allowEditing="false" :filter="filterDefault"
                  headerTextAlign="Left" />
                <e-column field="send_to_mails_dw" headerText="Maile DW" :allowEditing="false" :filter="filterDefault"
                  headerTextAlign="Left" />
                <e-column field="delivery_date_deadline" headerText="Ostateczny termin dostawy" :allowEditing="true"
                  :filter="filterDefault" format="dd.MM.yyyy" type="date" editType="datepickeredit"
                  headerTextAlign="Left" />
                <e-column field="payment_method" headerText="Forma płatności" :allowEditing="true" type="string"
                  :filter="filterPaymentMethods" editType="dropdownedit" :edit="orderPaymentMethodsParams"
                  :dataSource="order_payment_methods" headerTextAlign="Left" />
                <e-column field="value_netto" headerText="Wartość netto" :allowEditing="false" :filter="filterNumeric"
                  editType="numericedit" format="N2" type="number" textAlign="Right" headerTextAlign="Left" />
                <e-column field="value_brutto" headerText="Wartość brutto" :allowEditing="false" :filter="filterNumeric"
                  editType="numericedit" format="N2" type="number" textAlign="Right" headerTextAlign="Left" />
                <e-column field="kwota_rabat" headerText="Wartość rabatu" :allowEditing="false" :filter="filterNumeric"
                  editType="numericedit" format="N2" type="number" textAlign="Right" headerTextAlign="Left" />
                <e-column field="value_netto_po_rabacie" headerText="Wartość netto po rabacie" :allowEditing="false"
                  :filter="filterNumeric" editType="numericedit" format="N2" type="number" textAlign="Right"
                  headerTextAlign="Left" />
                <e-column field="value_brutto_po_rabacie" headerText="Wartość brutto po rabacie" :allowEditing="false"
                  :filter="filterNumeric" editType="numericedit" format="N2" type="number" textAlign="Right"
                  headerTextAlign="Left" />
                <e-column field="currency" headerText="Waluta" :allowEditing="false" :filter="filterDefault"
                  textAlign="Right" headerTextAlign="Left" />
                <e-column field="euro_rate" headerText="Kurs Euro" :allowEditing="false" format="N4"
                  :filter="filterNumeric" type="number" textAlign="Right" headerTextAlign="Left" />
                <e-column field="advance" headerText="Zaliczka" :allowEditing="true" editType="numericedit" format="N2"
                  :filter="filterNumeric" type="number" textAlign="Right" headerTextAlign="Left" />
                <e-column field="status" headerText="Status" :allowEditing="true" editType="dropdownedit" type="string"
                  :dataSource="order_list_statuses" :edit="orderItemStatusesParams" :filter="filterStatuses"
                  :template="'statusWithColorTemplateIndex'" headerTextAlign="Left" />
                <e-column field="comment" headerText="Komentarz do zamówienia" :allowEditing="true"
                  :allowFiltering="false" :allowSorting="false" headerTextAlign="Left" />
                <e-column field="created_at" headerText="Data utworzenia" :allowEditing="false" type="date"
                  format="dd.MM.yyyy" :filter="filterDefault" headerTextAlign="Left" />
                <e-column field="required_project_created_by_names" headerText="Zlecone przez" :allowEditing="false"
                  :filter="filterDefault" headerTextAlign="Left" />
                <e-column field="created_by_name" headerText="Utworzone przez" :allowEditing="false"
                  :filter="filterDefault" headerTextAlign="Left" />
                <e-column field="order_links" headerText="Linki" width="200" :allowSorting="false"
                  :template="'linksOrderListTemplate'" :allowEditing="false" :allowFiltering="false" :visible="true"
                  headerTextAlign="Left" />
                <e-column field="order_files" headerText="Załączniki" width="200" :allowSorting="false"
                  :template="'attachmentsOrderListTemplate'" :allowEditing="false" :allowFiltering="false"
                  headerTextAlign="Left" />
                <e-column field="required_project_release_by_names" headerText="Zwolnione przez" :allowEditing="false"
                  :filter="filterDefault" headerTextAlign="Left" />
              </e-columns>
              <template v-slot:indexTemplate="{ data }">
                <span style="color:#a6a6a6">
                  {{ getRowIndex(data) }}
                </span>
              </template>

              <template v-slot:wasEditedLaterTemplate="{ data }">
                <span v-if="data.required_project_was_edited_later"
                  style="color: white; background-color: orangered; font-size:16px; font-weight: 700; width: 20px; display: block; text-align: center">
                  !
                </span>
              </template>
              <e-aggregates>
                <e-aggregate>
                  <e-columns>
                    <e-column field="value_netto_po_rabacie" type="Custom" :customAggregate="nettoByCurrency"
                      footerTemplate="<b>${Custom}</b>" />
                    <e-column field="value_brutto_po_rabacie" type="Custom" :customAggregate="bruttoByCurrency"
                      footerTemplate="<b>${Custom}</b>" />
                  </e-columns>
                </e-aggregate>
              </e-aggregates>

              <template v-slot:deliverersShortNamesTemplate="{ data }">
                {{ formatDeliverers(data) }}
              </template>
              <template v-slot:statusWithColorTemplateIndex="{ data }">
                <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 100%;">
                  <span v-if="data.bg_status_colors?.length" :style="{
                    backgroundColor: data.bg_status_colors[0],
                    width: '20px',
                    height: '20px',
                    display: 'inline-block',
                    borderRadius: '4px',
                    verticalAlign: 'middle',
                    marginRight: '8px'
                  }" :title="data.status"></span>
                  <span style="vertical-align: middle;">
                    {{ data.status }}
                  </span>
                </div>
              </template>
              <template v-slot:linksOrderListTemplate="{ data }">
                <div v-if="data.order_links && data.order_links.length" style="display: table; width: 100%;">
                  <div style="display: table-cell; width: 1%; text-align: left; white-space: nowrap;">
                    <button class="btn btn-xs btn-outline-default" @click="showOrderListLinksModal(data)">
                      +{{ data.order_links.length }}
                    </button>
                  </div>
                  <div style="display: table-cell;">
                    <a class="text-primary" :href="data.order_links[0].url" target="_blank"
                      :title="data.order_links[0].url">
                      {{ shortenFileName(data.order_links[0].url, 25) }}
                    </a>
                  </div>
                </div>
              </template>
              <template v-slot:attachmentsOrderListTemplate="{ data }">
                <div style="display: table; width: 100%;">
                  <div style="display: table-cell; width: 1%; text-align: left; white-space: nowrap;">
                    <button class="btn btn-xs btn-outline-default" @click="showOrderListAttachmentsModal(data)">
                      +{{ (data.quote_requests_files?.length || 0) + (data.order_files?.length ||
                        0) }}
                    </button>
                  </div>
                  <div style="display: table-cell;">
                    <a v-if="data.quote_requests_files?.length" class="text-primary ms-2"
                      :href="route('quoteRequests.files.show', { file: data.quote_requests_files[0].id })"
                      target="_blank" :title="data.quote_requests_files[0].original_name">
                      {{ shortenFileName(data.quote_requests_files[0].original_name, 25) }}
                    </a>
                    <a v-else-if="data.order_files?.length" class="text-primary ms-2"
                      :href="route('orderList.files.show', { file: data.order_files[0].id })" target="_blank"
                      :title="data.order_files[0].original_name">
                      {{ shortenFileName(data.order_files[0].original_name, 25) }}
                    </a>
                  </div>
                </div>
              </template>
            </ejs-grid>
          </div>
          <div class="row">
            <div class="col-12 p-0" v-if="selectedOrder">
              <SelectedOrderItems :orderListId="orderListId" :order_list_statuses="order_list_statuses"
                :order_payment_methods="order_payment_methods" :producers="producers"
                :table_settings="table_settings_selected" :categories="categories" title="Zamówienie"
                :selectedOrder="selectedOrder" :userID="userID" @refresh="this.$refs.orderListGrid.refresh()"
                :suppliers="suppliers" :units="units" :currencys="currencys" :selectedProjectId="selectedProjectId"
                :selectedTeamName="selectedTeamName" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <SendOrdersModal v-if="showSendOrdersModal" ref="sendOrderModal" :selectedItems="selectedRecordsToMove"
      @refresh="this.$refs.orderListGrid.refresh()" @added-success="successMsg" @added-error="errorMsg"
      @clear-selection="clearSelection" />

    <QuoteRequestsFilesModalMulti v-if="showQuoteRequestModalMulti" :quoteRequests="selectedRecordsStat"
      @close="showQuoteRequestModalMulti = false" :canAdd="false" :canRemove="false"
      @refresh="this.$refs.quoteListGrid.refresh()" @added-success="successMsg" @added-error="errorMsg" />

    <OrderListFilesModal v-if="showOrderListModal" :orderList="selectedArticle" :quoteRequests="selectedArticle"
      @close="showOrderListModal = false" @refresh="this.$refs.orderListGrid.refresh()" @added-success="successMsg"
      @added-error="errorMsg" />

    <OrderListLinksModal v-if="showLinksListModal" :orderList="selectedArticle" @close="showLinksListModal = false"
      @refresh="this.$refs.orderListGrid.refresh()" @added-success="successMsg" @added-error="errorMsg" />

    <OrderListFilesModalMulti v-if="showOrderListModalMulti" :orderLists="selectedRecordsStat"
      @close="showOrderListModalMulti = false" @refresh="this.$refs.orderListGrid.refresh()" @added-success="successMsg"
      @added-error="errorMsg" />

    <ChangeOrderListStatusModal v-if="showChangeOrderListStatusModal" :selectedRecords="selectedRecordsStat"
      :statuses="prepareStatuses()" ref="changeStatusModalRef" :userID="userID"
      @updated-article="this.$refs.orderListGrid.refresh()" @added-success="successMsg" @added-error="errorMsg"
      @clear-selection="clearSelection" />
    <ChangeOrderNegotiationModal v-if="showChangeOrderNegotiationModal" :selectedRecords="selectedRecordsStat"
      ref="changeNegotiationModalRef" :userID="userID" :negotiations="negotiations"
      @updated-article="this.$refs.orderListGrid.refresh()" @added-success="successMsg" @added-error="errorMsg"
      @clear-selection="clearSelection" />


    <ChangeOrderModal v-if="showChangeOrderModal" ref="changeOrderModalRef" :order-comment="selectedOrderComment"
      :project="selectedProjectId" :team="selectedTeamName" context="from_required_project"
      :selectedItems="selectedRecordsToMove" :order_where_list="order_where_list" :currencys="currencys"
      @added-success="successMsg" @added-error="errorMsg" @refresh="this.$refs.requiredProjectItemsGrid.refresh()"
      @clear-selection="clearSelection" />

    <ChangeOrderDateModal v-if="showChangeOrderDateModal" :selectedRecords="selectedRecordsStat"
      :statuses="prepareStatuses()" ref="changeDateModalRef" @updated-article="this.$refs.orderListGrid.refresh()"
      @added-success="successMsg" @added-error="errorMsg" @clear-selection="clearSelection" />
    <EditOrderModal v-if="showEditOrderModal" ref="editOrderModalRef" :order-comment="selectedOrderComment"
      :order-where="selectedOrderWhere" :project="selectedProjectId" :team="selectedTeamName"
      context="from_required_project" :selectedItems="selectedRecordsToMove" :order_where_list="order_where_list"
      :currencys="currencys" @added-success="successMsg" @added-error="errorMsg"
      @refresh="this.$refs.requiredProjectItemsGrid.refresh()" @clear-selection="clearSelection" />
  </AppLayout>
</template>

<script>
import AppLayout from "../../Layouts/App.vue";
import { router, usePage } from "@inertiajs/vue3";
import { MultiSelect } from '@syncfusion/ej2-vue-dropdowns';
import {
  ColumnChooser,
  ColumnDirective,
  ColumnsDirective,
  ContextMenu,
  Edit,
  ExcelExport,
  Filter, ForeignKey,
  GridComponent,
  AggregatesDirective,
  AggregateDirective,
  Page,
  Reorder,
  Aggregate,
  Resize,
  Sort,
  Toolbar,
} from '@syncfusion/ej2-vue-grids';
import { createElement } from "@syncfusion/ej2-base";
import { DataManager, WebMethodAdaptor, Query, Predicate } from '@syncfusion/ej2-data';
import { ComboBox, DropDownList } from "@syncfusion/ej2-dropdowns";
import moment from "moment";
import { ref } from "vue";
import SendOrdersModal from "./SendOrdersModal.vue";
import SelectedOrderItems from "./SelectedOrderItems.vue";
import MoveItemToWarehouseModal from "./MoveItemToWarehouseModal.vue";
import OrderListFilesModal from "../OrderLists/OrderListFilesModal.vue";
import OrderListLinksModal from "../OrderLists/OrderListLinksModal.vue";
import QuoteRequestsFilesModal from "../QuoteRequests/QuoteRequestsFilesModal.vue";
import QuoteRequestsFilesModalMulti from "../QuoteRequests/QuoteRequestsFilesModalMulti.vue";
import OrderListFilesModalMulti from "../OrderLists/OrderListFilesModalMulti.vue";
import { usePermission } from "@/composables/resources/js/composables/permissions.js";
import ChangeOrderListStatusModal from "../QuoteRequests/ChangeOrderListStatusModal.vue";
import ChangeOrderDateModal from "./ChangeOrderDateModal.vue";
import ChangeOrderNegotiationModal from "./ChangeOrderNegotiationModal.vue";
import ChangeOrderModal from "../QuoteRequests/ChangeOrderModal.vue";
import EditOrderModal from "../QuoteRequests/EditOrderModal.vue";

const { hasPermission } = usePermission();

let dropInstanceFilterUnits, statusElem, statusObj, statusFilter;
export default {

  components: {
    QuoteRequestsFilesModal,
    QuoteRequestsFilesModalMulti,
    ChangeOrderListStatusModal,
    ChangeOrderNegotiationModal,
    ChangeOrderDateModal,
    OrderListFilesModal,
    OrderListLinksModal,
    OrderListFilesModalMulti,
    MoveItemToWarehouseModal,
    SelectedOrderItems,
    SendOrdersModal,
    AppLayout,
    ChangeOrderModal,
    EditOrderModal,
    MultiSelect,
    'ejs-grid': GridComponent,
    'e-columns': ColumnsDirective,
    'e-column': ColumnDirective,
    "e-aggregates": AggregatesDirective,
    "e-aggregate": AggregateDirective
  },

  provide: {
    grid: [Page, Edit, Toolbar, ContextMenu, Sort, Filter, Reorder, Resize, ColumnChooser, ExcelExport, ForeignKey, Aggregate]
  },

  props: {
    projects: Object,
    order_list_statuses: Object,
    order_payment_methods: Object,
    units: Object,
    categories: Object,
    producers: Object,
    suppliers: Object,
    locations: Object,
    warehouses: Object,
    userID: Number,
    negotiations: Object,
    order_where_list: Array,
    currencys: Object,
    table_settings: {
      type: Object,
      now_restore_table: {
        type: Number,
        default: 1
      },
      default: null
    },
    table_settings_selected: {
      type: Object,
      now_restore_table_items: {
        type: Number,
        default: 1
      },
      default: null
    }
  },
  beforeMount() {
    const storedProjectId = sessionStorage.getItem('selectedProjectId');
    const storedTeam = sessionStorage.getItem('selectedTeam');
    this.archivedShown = sessionStorage.getItem('archivedShown');

    if (storedProjectId) {
      this.selectedProjectId = (storedProjectId === 'null' || storedProjectId === null) ? 0 : storedProjectId;
      this.updateTeams();
    }

    this.selectedTeamName = storedTeam;
    this.getRequiredProjectItemsForProject();
  },
  created() {
    const urlParams = new URLSearchParams(window.location.search);
    this.defaultStatus = urlParams.get('status');
  },
  mounted() {
    this.restoreTableIfNeeded();
    this.calculateGridHeight();
    window.addEventListener('resize', this.calculateGridHeight);

    this.$nextTick(() => {
      const grid = this.$refs.orderListGrid?.ej2Instances;
      grid.search("");
      this.hasSearch = false;
      if (grid) {

        this.$refs.orderListGrid.ej2Instances.refresh();
      }
      const gridEl = document.getElementById('orderListGridId');
      if (gridEl) {
        gridEl.addEventListener('mousedown', (e) => {
          if (e.which === 3) { // PPM
            this.preventRightClickSelection = true;
          }
        });
      }
    });
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.calculateGridHeight)
  },

  data() {
    return {
      tableSettingsApplied: false,
      hasTableSettings: false,
      hasSearch: false,
      gridRetryCount: 0,
      gridRetryTimer: null,
      clickedRowId: null,
      isFilterOpen: false,
      gridHeight: '64vh',
      hasPermission,
      preventRightClickSelection: false,
      shouldCollapseByInitial: true,
      teams: [],
      defaultStatus: '',
      archivedShown: false,
      orderListDataManager: [],
      fetchedOrders: [],
      selectedProjectId: 0,
      selectedTeamName: null,
      selectedRecordsToMove: null,
      selectedOrder: null,
      selectedArticle: null,
      orderListId: null,
      showQuoteRequestModal: false,
      showSendOrdersModal: false,
      showOrderListModal: false,
      showLinksListModal: false,
      showQuoteRequestModalMulti: false,
      showOrderListModalMulti: false,
      showChangeOrderListStatusModal: false,
      showChangeOrderNegotiationModal: false,
      showChangeOrderModal: false,
      showChangeOrderDateModal: false,
      showEditOrderModal: false,
      addRequiredProjectItemsModalRef: ref(null),
      editArticleModalRef: ref(null),
      showEditArticleModal: false,
      selectedArticleToEdit: null,
      selectedRecordsToSendOrder: null,
      selectedRecordsStat: [],
      pageSettings: { pageSize: 30, pageCount: 5, pageSizes: [10, 20, 30, 50, 100] },
      filterOptions: { type: "Menu", operator: 'contains', },
      filterDefault: { operator: 'contains', params: { minLength: 2 } },
      filterNumeric: { operator: 'equal' },
      isRestoring: false,
      editSettings: this.getEditSettings(),
      selectionOptions: { type: 'Multiple', persistSelection: true, checkboxOnly: true },
      contextMenuItems: this.getContextMenu(),
      editNumbersPlusParams: {
        params: {
          min: 0,
          validateDecimalOnType: true
        }
      },

      wasEditedLaterEdit: {
        params: {
          dataSource: [
            { text: 'Tak', value: 1 },
            { text: 'Nie', value: 0 }
          ],
          query: new Query(),
          fields: { text: 'text', value: 'value' }
        }
      },

      filterUnits: {
        operator: 'contains',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', { className: 'flm-input' });
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.units,
              fields: { text: 'name', value: 'id' },
              placeholder: 'Szukaj jednostki',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },

      filterCategories: {
        operator: 'contains',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', { className: 'flm-input' });
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.categories,
              fields: { text: 'name', value: 'id' },
              placeholder: 'Szukaj kategorii',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },

      filterProducers: {
        operator: 'contains',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', { className: 'flm-input' });
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.producers,
              fields: { text: 'short_name', value: 'id' },
              placeholder: 'Szukaj producentów',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },

      filterNegotiations: {
        operator: 'contains',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', { className: 'flm-input' });
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.negotiations,
              fields: { text: 'name', value: 'id' },
              placeholder: 'Szukaj negocjacji',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },
      filterSuppliers: {
        operator: 'contains',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', { className: 'flm-input' });
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.suppliers,
              fields: { text: 'short_name', value: 'short_name' },
              placeholder: 'Szukaj dostawców',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },

      filterWarehouses: {
        operator: 'contains',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', { className: 'flm-input' });
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.warehouses,
              fields: { text: 'short_name', value: 'id' },
              placeholder: 'Szukaj magazynu',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },

      filterStatuses: {
        ui: {
          create: (args) => {
            let flValInput = createElement('input', { className: 'flm-input' });
            args.target.appendChild(flValInput);
            statusFilter = new DropDownList({
              dataSource: this.order_list_statuses,
              fields: { text: 'name', value: 'id' },
              placeholder: 'Szukaj Statusu',
              popupHeight: '200px',
              allowFiltering: true
            });
            statusFilter.appendTo(flValInput);
          },
          write: (args) => {
            statusFilter.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, statusFilter.text);
          }
        }
      },

      orderItemStatusesParams: {
        create: () => {
          statusElem = createElement('input');
          return statusElem;
        },
        read: () => {
          return statusObj.value;
        },
        destroy: () => {
          statusObj.destroy();
        },
        write: (args) => {
          statusObj = new DropDownList({
            dataSource: this.order_list_statuses,
            fields: { value: 'name', text: 'name' },
            enabled: true,
            placeholder: 'Wybierz status',
            floatLabelType: 'Never',
            value: args.rowData.status?.id,
            change: async (event) => {
              statusObj.value = await this.onChangeStatus(event, args.rowData);
            }
          });
          statusObj.appendTo(statusElem);
        }
      },

      orderItemNegotiations: {
        create: () => {
          negoElem = createElement('input');
          return negoElem;
        },
        read: () => {
          return negoObj.value;
        },
        destroy: () => {
          negoObj.destroy();
        },
        write: (args) => {
          negoObj = new DropDownList({
            dataSource: this.negotiations,
            fields: { value: 'name', text: 'name' },
            enabled: true,
            placeholder: 'Wybierz',
            floatLabelType: 'Never',
            value: args.rowData.negotiation_name?.id,
          });
          negoObj.appendTo(negoElem);
        }
      },

      inventoryStatusesParams: {
        create: () => {
          statusElem = document.createElement('input');
          return statusElem;
        },
        read: () => {
          return statusObj.text;
        },
        destroy: () => {
          statusObj.destroy();
        },
        write: () => {
          statusObj = new DropDownList({
            dataSource: this.inventory_statuses,
            fields: { value: 'name', text: 'name' },
            enabled: true,
            placeholder: 'Wybierz status',
            floatLabelType: 'Never'
          });
          statusObj.appendTo(statusElem);
        }
      },

      filterPaymentMethods: {
        ui: {
          create: (args) => {
            let flValInput = createElement('input', { className: 'flm-input' });
            args.target.appendChild(flValInput);
            statusFilter = new DropDownList({
              dataSource: this.order_payment_methods,
              fields: { text: 'name', value: 'name' },
              placeholder: 'Szukaj metody płatności',
              popupHeight: '200px',
              allowFiltering: true
            });
            statusFilter.appendTo(flValInput);
          },
          write: (args) => {
            statusFilter.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, statusFilter.text);
          }
        }
      },

      orderPaymentMethodsParams: {
        create: () => {
          statusElem = createElement('input');
          return statusElem;
        },
        read: () => {
          return statusObj.value;
        },
        destroy: () => {
          statusObj.destroy();
        },
        write: (args) => {
          statusObj = new DropDownList({
            dataSource: this.order_payment_methods,
            fields: { value: 'name', text: 'name' },
            enabled: true,
            placeholder: 'Wybierz metodę płatności',
            floatLabelType: 'Never',
            value: args.rowData.status?.id,
          });
          statusObj.appendTo(statusElem);
        }
      },
    }
  },
  watch: {
    table_settings: {
      immediate: true,
      deep: true,
      handler(value) {
        this.hasTableSettings = !!(value?.settings);
      }
    }
  },
  computed: {
    toolbar() {
      return this.getToolbar();
    }
  },
  methods: {
    truncateLabel(label) {
      if (!label) return '';
      return label.length > 40 ? label.substring(0, 40) + '...' : label;
    },

    updateSelectedProject() {
      // Twoja dotychczasowa logika
    },
    onGridActionFailure(args) {
      console.error('Błąd Syncfusion Grid:', args);

      const message =
        args?.error?.error?.message ||
        args?.error?.message ||
        '';

      if (!message.includes('NetworkError')) {
        return;
      }

      if (this.gridRetryCount >= 3) {
        console.error('Nie udało się pobrać danych po 3 próbach.');
        return;
      }

      this.gridRetryCount++;

      clearTimeout(this.gridRetryTimer);

      const attempt = this.gridRetryCount;

      this.gridRetryTimer = setTimeout(() => {
        const grid = this.$refs.orderListGrid?.ej2Instances;

        if (!grid || !this.orderListDataManager) {
          return;
        }

        console.warn(`Ponawiam pobieranie danych: próba ${attempt}/3`);

        grid.refresh();
      }, 1000 * attempt);
    },

    restoreTableIfNeeded() {
      if (this.now_restore_table !== 0) {
        return;
      }

      let grid = this.$refs.orderListGrid;

      if (!grid || !grid.$el || !grid.ej2Instances) {
        return;
      }

      let gridName = 'grid' + grid.$el.id;

      grid.ej2Instances.enablePersistence = false;

      window.localStorage.setItem(gridName, "");

      grid.ej2Instances.destroy();

      (function stripIdsFromUrl() {
        try {
          const url = new URL(window.location.href);

          url.searchParams.delete('ids');
          url.searchParams.delete('ids[]');

          history.replaceState(
            history.state,
            '',
            url.toString()
          );
        } catch (e) {
          const href = window.location.href;

          const cleaned = href
            .replace(/([?&])ids(\[\])?=[^&#]*&?/g, '$1')
            .replace(/[?&]$/, '');

          history.replaceState(
            history.state,
            '',
            cleaned
          );
        }
      })();
      this.applyTableSettings();
      location.reload();
    },

    getRowIndex(data) {
      const grid = this.$refs.orderListGrid?.ej2Instances;
      const pageSize = grid?.pageSettings?.pageSize ?? 30;
      const currentPage = grid?.pageSettings?.currentPage ?? 1;
      const index = Number(data.index);
      return ((currentPage - 1) * pageSize) + (index % pageSize) + 1;
    },
    applyTableSettings() {
      const grid = this.$refs.orderListGrid?.ej2Instances;

      if (!grid || !this.table_settings?.settings) {
        return;
      }

      let settings;

      try {
        settings = JSON.parse(this.table_settings.settings);
      } catch (error) {
        console.error('Błąd odczytu ustawień tabeli:', error);
        return;
      }

      if (!Array.isArray(settings)) {
        return;
      }

      settings.forEach(setting => {
        if (!setting.field) {
          return;
        }

        const column = grid.columns.find(
          col => col.field === setting.field
        );

        if (!column) {
          return;
        }

        if (setting.width !== undefined) {
          column.width = setting.width;
        }

        column.visible = setting.visible !== false;
      });

      grid.refreshColumns();

      const savedFields = settings
        .filter(setting => setting.field)
        .sort((a, b) => a.index - b.index)
        .map(setting => setting.field);
      const currentFields = grid.columns
        .filter(column => column.field)
        .map(column => column.field);

      savedFields.forEach((field, targetIndex) => {
        const currentIndex = currentFields.indexOf(field);

        if (currentIndex === -1 || currentIndex === targetIndex) {
          return;
        }

        const targetField = currentFields[targetIndex];

        if (!targetField) {
          return;
        }

        grid.reorderColumns(
          field,
          targetField
        );

        currentFields.splice(currentIndex, 1);
        currentFields.splice(targetIndex, 0, field);
      });

      grid.refreshColumns();
    },

    queryCellInfo(args) {
      if (args.column.field === 'delivery_date_deadline') {
        const diffDays = this.DeliveryDeadlineDates(args.data.delivery_date_deadline, args.data.status);

        if (diffDays > 0) {
          args.cell.style.backgroundColor = 'red';
          args.cell.style.color = 'white';
        }
      }
    },

    DeliveryDeadlineDates(deliveryDate, status) {
      if (!deliveryDate) {
        return null;
      }
      if (status?.trim() === "Zrealizowane" || status?.trim() === "Anulowane") {
        return null;
      }
      const deliverDate = new Date(deliveryDate);
      const today = new Date();

      today.setHours(0, 0, 0, 0);
      deliverDate.setHours(0, 0, 0, 0);

      const diffTime = today - deliverDate;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      return diffDays > 0 ? diffDays : 0;
    },

    headerCellInfoEvent: function (args) {
      // pokazywanie tooltipów po najechanie na header
      /*   new Tooltip(
             {
               content: args.cell.column.headerTooltip
             },
             args.node
         );
         */
    },

    dataBoundHandler() {
      if (!this.tableSettingsApplied) {
        this.tableSettingsApplied = true;
        this.applyTableSettings();
      }
      const grid = this.$refs.orderListGrid.ej2Instances;

      const hasSearchNow = !!grid.searchSettings.key;

      if (this.hasSearch !== hasSearchNow) {
        this.hasSearch = hasSearchNow;
        this.toolbar = this.getToolbar();
      }

      const selectAll = grid.element.querySelector('.e-checkselectall')?.closest('th');

      if (selectAll && !selectAll.dataset.customSelect) {
        selectAll.dataset.customSelect = "true";

        selectAll.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          const records = grid.getCurrentViewRecords();
          const indexes = records.map((_, index) => index);

          const selectedIndexes = grid.getSelectedRowIndexes();
          const allSelected = indexes.every(index => selectedIndexes.includes(index));

          if (allSelected) {
            // odznacz wszystkie z bieżącej strony
            grid.clearSelection();
          } else {
            // zaznacz wszystkie z bieżącej strony
            grid.selectRows(indexes);
          }

        }, true);
      }
    },

    shortenFileName(fileName, maxLength = 25) {
      if (!fileName) return '';

      if (fileName.length <= maxLength) {
        return fileName;
      }

      return fileName.substring(0, maxLength) + '...';
    },
    /*
    excelQueryCellInfoHandler(args) {
    const badFields = [
      'quote_requests',
      'order_files',
      'quote_requests_files',
      'dw_warehouse_movements'
    ];
  
    if (badFields.includes(args.column.field)) {
      const val = args.data?.[args.column.field];
  
      if (Array.isArray(val)) {
        args.value = val.length
          ? val.map(v => v.order_number || v.quote_request_number || v.id).join(', ')
          : '';
      } else {
        args.value = '';
      }
    }
  },
  */
    nettoByCurrency: function (data) {
      const rows = data?.result || data?.records || [];

      const sums = {};

      rows.forEach(r => {
        const cur = r.currency || 'BRAK';
        const val = Number(r.value_netto_po_rabacie || 0);

        sums[cur] = (sums[cur] || 0) + val;
      });

      const format = new Intl.NumberFormat('pl-PL', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

      const formatNumber = (value) =>
        format.format(value).replace(/\u00A0/g, ' ');

      return Object.entries(sums)
        .map(([cur, sum]) => `<b>${formatNumber(sum)} ${cur}</b>`)
        .join('<br/>');
    },

    bruttoByCurrency: function (data) {
      const rows = data?.result || [];

      const sums = {};

      rows.forEach(r => {
        const cur = r.currency || 'BRAK';
        const val = Number(r.value_brutto_po_rabacie || 0);

        sums[cur] = (sums[cur] || 0) + val;
      });

      const format = new Intl.NumberFormat('pl-PL', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

      const formatNumber = (value) =>
        format.format(value).replace(/\u00A0/g, ' ');

      return Object.entries(sums)
        .map(([cur, sum]) => `<b>${formatNumber(sum)} ${cur}</b>`)
        .join('<br/>');
    },
    clearSelection() {
      this.selectedRecordsStat = [];
      this.selectedRecordsToMove = [];

      this.$nextTick(() => {
        const grid = this.$refs.orderListGrid?.ej2Instances;

        if (!grid) return;

        grid.clearSelection();
        grid.refresh();
      });


    },
    calculateGridHeight() {
      const topOffset =
        document.getElementById('orderListGridId')
          ?.getBoundingClientRect().top || 200
      this.gridHeight = `${window.innerHeight - topOffset - 140}px`
    },

    getEditSettings() {
      return {
        allowEditing: hasPermission('canEditOrders') || hasPermission('canChangeStatusApprovalOrders'),
        allowAdding: hasPermission('canEditOrders'),
        allowDeleting: hasPermission('canEditOrders'),
        showConfirmDialog: false,
        showDeleteConfirmDialog: false,
        mode: 'Batch',
        newRowPosition: 'Top',
      };
    },

    diffAggregateFn: function (data) {
      if (!data.result)
        return;

      let totalRequired = data.result
        .map(item => item.quantity_required || 0)
        .reduce((acc, value) => acc + parseFloat(value), 0);

      let totalDelivered = data.result
        .map(item => item.delivered_quantity || 0)
        .reduce((acc, value) => acc + parseFloat(value), 0);

      let difference = totalRequired - totalDelivered;

      this.differenceValue = difference;

      if (this.differenceValue == 0)
        return 'Ilość zgodna';
      if (this.differenceValue > 0)
        return 'Brakuje ' + difference.toFixed(2) + ' jdn.';
      else
        return 'Nadwyżka ' + -difference.toFixed(2) + ' jdn.';
    },

    getToolbar() {
      const tools = [];
      const hasSearch = this.$refs.orderListGridId?.ej2Instances?.searchSettings?.key?.length > 0;

      if (hasPermission('canEditOrders')) {
        tools.push(
          "Cancel",
        )
      }

      const urlParams = new URLSearchParams(window.location.search)
      let isApprovalOrder = urlParams.get('status') === 'W zatwierdzeniu';
      if (hasPermission('canEditOrders') || (isApprovalOrder && hasPermission('canChangeStatusApprovalOrders'))) {
        tools.push(
          "Update",
        )
      }

      tools.push(
        { text: "Resetuj filtry", prefixIcon: 'e-reset', id: 'reset_filters' },
        { text: "Search", prefixIcon: 'e-search', id: "search", align: 'center' },
      );

      if (this.hasSearch) {
        tools.push({
          text: "",
          prefixIcon: "e-close",
          id: "clear_search",
          align: 'center'
        });
      }
      tools.push({ text: "Zapisz ustawienia", prefixIcon: 'e-save', id: "save", align: 'right' });
      if (this.hasTableSettings) {
        tools.push({ text: "Usuń ustawienia", prefixIcon: 'e-delete', id: "delete-set", align: 'right' });
      }
      tools.push({ text: "Przywróć domyślny", prefixIcon: 'e-undo', id: "restore", align: 'right' },
        { text: "Export do Excela", prefixIcon: 'e-excelexport', id: "excelexport", align: 'right' },
        "ColumnChooser",
      );

      return tools;
    },

    rowSelecting(args) {
      if (this.preventRightClickSelection) {
        args.cancel = true;
        this.preventRightClickSelection = false;

      }
    },

    clickToolbarHandler: async function (args) {

      if (args.item.id === "clear_search") {
        const grid = this.$refs.orderListGrid.ej2Instances;

        grid.search("");

        this.hasSearch = false;
        this.toolbar = this.getToolbar();
      }

      if (args.item.text === 'Usuń') {
        const selectedRecords = this.$refs.orderListGrid.getSelectedRecords();
        if (selectedRecords.length > 0) {
          selectedRecords.forEach((record) => {
            this.$refs.orderListGrid.deleteRecord("id", record);
          });
        }
      }

      if (args.item.id === 'reset_filters') {
        this.$refs.orderListGrid.clearFiltering();
      }
      if (args.item.id === 'save') {
        const grid = this.$refs.orderListGrid?.ej2Instances;

        if (!grid) {
          console.warn('Grid nie został znaleziony');
          this.errorMsg("Konfiguracja tabeli nie została zapisana!");
          return;
        }
        const tableId = 'orderListGrid';
        const settings = grid.columns.map((column, index) => ({
          field: column.field || null,
          index: index,
          width: column.width,
          visible: column.visible !== false
        }));
        try {
          const response = await axios.post('/table-settings', {
            tableId: tableId,
            columns: JSON.stringify(settings)
          });
          this.hasTableSettings = true;
          this.successMsg("Konfiguracja tabeli została pomyślnie zapisana!");
        } catch (error) {
          this.errorMsg("Konfiguracja tabeli nie została zapisana!");
        }
      }
      if (args.item.id === 'delete-set') {
        const tableId = 'orderListGrid';
        try {
          const response = await axios.delete('/table-settings-delete', {
            data: {
              tableId: tableId
            }
          }
          );
          this.hasTableSettings = false;
          this.successMsg(
            "Konfiguracja tabeli została pomyślnie usunięta!"
          );
        } catch (error) {
          this.errorMsg(
            "Konfiguracja tabeli nie została usunięta!"
          );
        }
      }

      if (args.item.id === 'restore') {
        let grid = this.$refs.orderListGrid;
        let gridName = 'grid' + grid.$el.id;
        grid.ej2Instances.enablePersistence = false;
        window.localStorage.setItem(gridName, "");
        grid.ej2Instances.destroy();
        this.applyTableSettings();
        location.reload();
      }

      if (args.item.id === 'excelexport') {

        const grid = this.$refs.orderListGrid;

        const hiddenColumns = [
          'order_files',
          'was_edited_later',
          'order_links'
        ];

        hiddenColumns.forEach(field => {
          const col = grid.getColumnByField(field);
          if (col) {
            col.visible = false;
          }
        });

        grid.refreshColumns();

        grid.excelExport({
          fileName: 'Zamówienia.xlsx'
        }).then(() => {

          hiddenColumns.forEach(field => {
            const col = grid.getColumnByField(field);
            if (col) {
              col.visible = true;
            }
          });

          grid.refreshColumns();
        });
      }



    },
    async onRowClick(args) {
      if (args.target?.closest('.e-checkbox-wrapper')) {
        return;
      }
      if (!args.rowData) return;
      this.orderListId = args.rowData.id;
      this.selectedOrder = args.rowData;
      this.clickedRowId = args.rowData.id;
      // this.$refs.orderListGrid.ej2Instances.refresh();
    },

    getContextMenu() {
      const contextMenu = [];

      if (hasPermission('canEditOrders')) {
        contextMenu.push(
          { text: 'Negocjacje', target: '.e-content', id: 'change_negotiation' },
          { text: 'Wyślij zamówienie', target: '.e-content', id: 'send_order', enabled: false },
        );
      }

      if (hasPermission('canChangeStatusApprovalOrders')) {
        contextMenu.push(
          { text: 'Zmień status', target: '.e-content', id: 'change_status' },
          { text: 'Zmień datę dostawy', target: '.e-content', id: 'change_date' },
        );

        const urlParams = new URLSearchParams(window.location.search);

        let isApprovalOrder1 = urlParams.get('status') === 'W zatwierdzeniu';
        let isApprovalOrder2 = urlParams.get('status') === 'Zatwierdzone';

        if (hasPermission('canEditOrders') && (isApprovalOrder1 || isApprovalOrder2)) {
          contextMenu.push(
            { text: 'Zmień dostawcę', target: '.e-content', id: 'change_supplier' },
            { text: 'Edytuj zamówienie', target: '.e-content', id: 'edit_order' }

          );
        }

        contextMenu.push(
          { separator: true },
          {
            text: 'Linki oferty',
            target: '.e-content',
            id: 'order_links_url'
          },
          {
            text: 'Załączniki oferty',
            target: '.e-content',
            id: 'quote_request_files_multi'
          },
          {
            text: 'Załączniki zamówienia',
            target: '.e-content',
            id: 'order_files_multi'
          }
        );
      }
      contextMenu.push({ separator: true },
        { text: 'Przejdź do zapotrzebowania', target: '.e-content', id: 'go_to_required' },
      );

      return contextMenu;
    },

    onContextMenuOpen(args) {
      const grid = this.$refs.orderListGrid;
      const selected = grid.getSelectedRecords();

      if (!selected.length) {
        args.cancel = true;
        return;
      }

      const rowData = this.$refs.orderListGrid.getRowInfo(args.event.target)?.rowData;
      const contextMenuInstance = args.element.ej2_instances[0];

      if (rowData?.status?.name === "W zatwierdzeniu") {
        contextMenuInstance.enableItems(["Wyślij zamówienie"], false); // Wyłącz opcję
      } else {
        contextMenuInstance.enableItems(["Wyślij zamówienie"], true); // Włącz opcję
      }
    },

    async clickContextMenuHandler(args) {
      const grid = this.$refs.orderListGrid.ej2Instances;
      const selected = grid.getSelectedRecords();
      const clickedRow = args?.rowInfo?.rowData;
      const records = selected.length ? selected : (clickedRow ? [clickedRow] : []);

      if (args.item.id === 'send_order') {
        if (records.length !== 1) {
          this.errorMsg('Wybierz dokładnie jedno zamówienie.');
          return;
        }

        this.selectedRecordsToMove = records;
        this.showSendOrdersModal = true;
        this.$nextTick(() => this.$refs.sendOrderModal.show());
      }

      if (args.item.id === 'change_status') {
        if (!records.length) {
          this.errorMsg('Nie wybrano żadnych pozycji.');
          return;
        }

        this.selectedRecordsStat = await this.getOrdersItems(records);
        this.showChangeOrderListStatusModal = true;
        this.$nextTick(() => {
          this.$refs.changeStatusModalRef.show();
        });
      }

      if (args.item.id === 'change_supplier') {
        if (records.length !== 1) {
          this.errorMsg('Wybierz dokładnie jedno zamówienie.');
          return;
        }

        const response = await axios.post(
          route('orderList.get-order-items'),
          {
            order_id: records[0].id
          }
        );

        this.selectedRecordsToMove = response.data.items;
        this.selectedOrderComment = response.data.comment;
        this.showChangeOrderModal = true;
        this.$nextTick(() => {
          this.$refs.changeOrderModalRef.show();
        });
      }

      if (args.item.id === 'edit_order') {
        if (records.length !== 1) {
          this.errorMsg('Wybierz dokładnie jedno zamówienie.');
          return;
        }

        const response = await axios.post(
          route('orderList.get-order-items'),
          {
            order_id: records[0].id
          }
        );

        this.selectedRecordsToMove = response.data.items;
        this.selectedOrderComment = response.data.comment;
        this.selectedOrderWhere = response.data.order_where;
        this.showEditOrderModal = true;
        this.$nextTick(() => {
          this.$refs.editOrderModalRef.show();
        });
      }


      if (args.item.id === 'change_negotiation') {
        if (!records.length) {
          this.errorMsg('Nie wybrano żadnych pozycji.');
          return;
        }

        this.selectedRecordsStat = await this.getOrdersItems(records);
        this.showChangeOrderNegotiationModal = true;
        this.$nextTick(() => {
          this.$refs.changeNegotiationModalRef.show();
        });
      }
      if (args.item.id === 'change_date') {
        if (!records.length) {
          this.errorMsg('Nie wybrano żadnych pozycji.');
          return;
        }

        this.selectedRecordsStat = await this.getOrdersItems(records);
        this.showChangeOrderDateModal = true;
        this.$nextTick(() => {
          this.$refs.changeDateModalRef.show();
        });
      }

      if (args.item.id === 'go_to_required') {
        const required_project_ids = records
          .flatMap(r => {
            const v = r?.required_project_ids;
            if (!v) return [];
            if (Array.isArray(v)) return v;
            return String(v).split(',');
          })
          .map(s => Number(s))
          .filter(Number.isFinite);
        if (!required_project_ids.length) {
          this.errorMsg('Brak powiązanych zapotrzebowań.');
          return;
        }

        router.get(route('requiredProjectItems.index'), {
          ids: [...new Set(required_project_ids)].join(',')
        }, {
          preserveState: true,
          preserveScroll: true,
          replace: true
        });
      }

      if (args.item.id === 'quote_request_files') {

        if (records.length !== 1) {
          this.errorMsg('Wybierz dokładnie jedną pozycję.');
          return;
        }

        this.selectedArticle = records[0];

        this.$nextTick(() => {
          this.showQuoteRequestModal = true;
        });
      }

      if (args.item.id === 'quote_request_files_multi') {
        this.selectedRecordsStat = records.map(r => ({
          id: r.id,
          quote_requests: r.quote_requests,
          files: r.quote_requests_files || []
        }));

        this.$nextTick(() => {
          this.showQuoteRequestModalMulti = true;
        });
      }

      if (args.item.id === 'order_links_url') {
        if (records.length !== 1) {
          this.errorMsg('Wybierz dokładnie jedną pozycję.');
          return;
        }

        this.selectedArticle = records[0];

        this.$nextTick(() => {
          this.showLinksListModal = true;
        });
      }

      if (args.item.id === 'order_files') {
        if (records.length !== 1) {
          this.errorMsg('Wybierz dokładnie jedną pozycję.');
          return;
        }

        this.selectedArticle = records[0];

        this.$nextTick(() => {
          this.showOrderListModal = true;
        });
      }

      if (args.item.id === 'order_files_multi') {
        this.selectedRecordsStat = records.map(r => ({
          id: r.id,
          order_number: r.order_number,
          files: r.order_files || []
        }));

        this.$nextTick(() => {
          this.showOrderListModalMulti = true;
        });
      }

    },

    async getOrdersItems(orders) {

      const ids = Object.values(orders)
        .map(item => item.id)
        .filter(id => id != null);

      try {
        const response = await axios.post(route('orders-items-list.get', { ordersListIds: ids }), {
          withNegotiation: true
        });
        return response.data;
      } catch (error) {
        console.error(error);
      }
    },

    cellEdit(args) {
      if (!hasPermission('canEditOrders') && hasPermission('canChangeStatusApprovalOrders')) {
        if (args.columnName !== 'status') {
          args.cancel = true;
        }
      }
    },

    updateSelectedProject(event) {
      this.selectedProjectId = Number(event.target.value);
      this.teams = null;
      this.selectedTeamName = null;
      if (this.selectedProjectId) {
        this.updateTeams()
      }

      this.getRequiredProjectItemsForProject();
    },

    updateTeams() {
      if (this.selectedProjectId) {
        const project = this.projects.find(project => project.id === Number(this.selectedProjectId));
        if (project) {
          this.teams = project.teams;
          this.selectedTeamName = null;
        }
      } else {
        this.teams = [];
        this.selectedTeamName = null;
      }
    },

    updateSelectedTeam(event) {
      this.selectedTeamName = event.target.value;
      this.getRequiredProjectItemsForProject();
    },

    getRequiredProjectItemsForProject() {
      sessionStorage.setItem('selectedProjectId', this.selectedProjectId);
      sessionStorage.setItem('selectedTeam', this.selectedTeamName);
      sessionStorage.setItem('archivedShown', this.archivedShown);

      this.orderListDataManager = new DataManager({
        url: route('orderLists.getList', {
          project: this.selectedProjectId,
          team: this.selectedTeamName,
          status: this.defaultStatus
        }),
        adaptor: new WebMethodAdaptor(),
        batchUrl: route('orderLists.saveChanges'),
        updateUrl: route('orderLists.updateChanges'),
        crossDomain: true,
        headers: [
          { 'X-CSRF-TOKEN': usePage().props.csrf_token },
          { 'archivedShown': sessionStorage.getItem('archivedShown') || false }
        ],
      });

      this.$nextTick(() => {
        const grid = this.$refs.orderListGrid?.ej2Instances;

        if (grid) {
          grid.dataSource = this.orderListDataManager;
          grid.refresh();
        }
      });

    },

    rowDataBound(args) {
      if (args.data.deleted_at) {
        args.row.classList.add('text-muted', 'deleted-row');
      }

      if (args.data.id === this.clickedRowId) {
        args.row.classList.add('clicked-row');
      } else {
        args.row.classList.remove('clicked-row');
      }
    },

    changeShowArchived() {
      sessionStorage.setItem('archivedShown', this.archivedShown ?? false);
      if (this.$refs.orderListGrid) {
        document.getElementById('orderListGridId').ej2_instances[0].query = new Query().addParams('archivedShown', this.archivedShown);
      }
    },

    showQuoteRequestAttachmentsModal(article) {
      this.selectedArticle = article;
      this.showQuoteRequestModal = true;
    },

    showOrderListAttachmentsModal(article) {
      this.selectedArticle = article;
      this.showOrderListModal = true;
    },

    showOrderListLinksModal(article) {
      this.selectedArticle = article;
      this.showLinksListModal = true;
    },

    onKeyDown: function (args) {
      let keyCode = args.which || args.keyCode;
      let isCtrlKey = (args.ctrlKey || args.metaKey) ? true : ((keyCode === 17));

      // code 83 to 'S'
      if (isCtrlKey && keyCode === 83) {
        args.preventDefault();

        this.updateGrid();
      }
    },

    actionBeginHandler(args) {
      const grid = this.$refs.orderListGrid?.ej2Instances;

      if (
        grid &&
        (
          args.requestType === 'filtering' ||
          args.requestType === 'filterAfterOpen'
        )
      ) {
        grid.goToPage(1);
      }
      if (args.requestType === "searching") {

        const grid = this.$refs.orderListGrid.ej2Instances;
        const keys = args.searchString.split(";");

        const ignoredFields = [
          "quote_requests_files",
          "value_brutto_po_rabacie",
          "value_netto_po_rabacie",
          "kwota_rabat",
          "order_files",
          "order_links",
          "team_name",
          "send_to_mails",
          "send_to_mails_dw"
        ];

        this.values = args.searchString;

        let predicates = [];

        keys.forEach((key) => {

          grid.getColumns().forEach((col) => {

            if (!col.field) {
              return;
            }

            if (ignoredFields.includes(col.field)) {
              return;
            }

            predicates.push(
              new Predicate(col.field, "contains", key, true)
            );

          });

        });

        let predicate = predicates.length ? predicates[0] : null;

        for (let i = 1; i < predicates.length; i++) {
          predicate = predicate.or(predicates[i]);
        }

        grid.query = predicate
          ? new Query().where(predicate)
          : new Query();

        this.refresh = true;
        this.valueAssign = true;
        this.removeQuery = true;

        grid.refresh();

        return;
      }

    },
    actionCompleteHandler(args) {
      if (args.requestType === 'refresh' || args.requestType === 'paging' || args.requestType === 'sorting' || args.requestType === 'filtering' || args.requestType === 'searching') {
        this.gridRetryCount = 0;
      }
      if (args.requestType === "refresh") {

        const searchBar = document.getElementById(
          this.$refs.orderListGrid.ej2Instances.element.id + "_searchbar"
        );

        if (this.valueAssign) {
          searchBar.value = this.values;
          this.valueAssign = false;
        }

        if (searchBar.value.trim() === "" && this.removeQuery) {

          this.$refs.orderListGrid.ej2Instances.query = new Query();

          this.removeQuery = false;

          this.$refs.orderListGrid.ej2Instances.refresh();
        }
      }

      if (args.requestType === "batchsave") {

        if (args.changes && args.changes.changedRecords) {
          this.successMsg("Dane zostały pomyślnie zapisane!");
        } else if (args.error) {
          this.errorMsg("Wystąpił błąd podczas zapisu danych: " + args.error);
        }
      }

      if (args.requestType === "searching") {
        this.hasSearch = !!args.searchString;
        this.toolbar = this.getToolbar();
      }
    },
    async onChangeStatus(event, rowData) {
      // Jeżeli user zmienił status na Zrealizowane
      if (!event.itemData || event.itemData?.name !== 'Zrealizowane') {
        return;
      }


      // Sprawdź, czy dostarczona ilość === wydanej ilości. Jeśli NIE:
      if (parseFloat(rowData.delivered_quantity) !== parseFloat(rowData.dispatched_quantity)) {
        Toast.fire({
          toast: false,
          position: 'center',
          icon: 'warning',
          title: 'Zakończenie zamówienia',
          html: 'Aby dokończyć realizacje zamówienia, dostarczona ilość oraz wydana ilość musi być taka sama.',
          showClass: { popup: 'animate__animated animate__fadeInDown' },
          hideClass: { popup: 'animate__animated animate__fadeOutUp' },
          timer: false,
          showConfirmButton: false,
          showCancelButton: true,
          cancelButtonText: 'Ok, rozumiem',
        });

        // cofnij do poprzedniego statusu
        return event.previousItemData?.id;
      }

      const result = await Toast.fire({
        toast: false,
        position: 'center',
        icon: 'question',
        title: 'Zakończenie zamówienia',
        html: 'Czy na pewno chcesz zmienić status na zrealizowany? W tym momencie całe zamówienie zostanie zakończone, a wszystkie jego pozycje (oprócz anulowanych) zostaną wysłane na magazyn projektowy.',
        showClass: { popup: 'animate__animated animate__fadeInDown' },
        hideClass: { popup: 'animate__animated animate__fadeOutUp' },
        timer: false,
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        confirmButtonColor: 'success',
        showCancelButton: true,
        cancelButtonText: 'Nie',
      });

      if (result.isConfirmed) {
        let response = await axios.post(route('orderLists.order-completed', { orderList: rowData.id }))
        if (response.status === 200) {
          this.successMsg(response.data.message);
        }
        this.$refs.orderListGrid.refresh();
      } else {
        // cofnij do poprzedniego statusu
        return event.previousItemData?.id;
      }

    },

    updateGrid() {
      // aktualizuj
      let toolbar = document.getElementsByClassName('e-toolbar-left')[0];
      let buttons = toolbar.querySelectorAll('.e-toolbar-item');
      let updateButton = buttons[1].querySelector('button');


      if (updateButton) {
        updateButton.click();
      }
    },

    prepareStatuses() {
      if (this.defaultStatus === 'W zatwierdzeniu')
        return [{ id: 6, name: 'Zatwierdzone' }, { id: 5, name: 'Anulowane' }]

      return this.order_list_statuses
    },

    successMsg(resp) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: 'success',
        title: 'Sukces!',
        html: resp,
        showClass: { popup: 'animate__animated animate__fadeInDown' },
        hideClass: { popup: 'animate__animated animate__fadeOutUp' },
        timer: 2500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    },

    errorMsg(resp) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: 'warning',
        title: 'Błąd!',
        html: resp,
        showClass: { popup: 'animate__animated animate__fadeInDown' },
        hideClass: { popup: 'animate__animated animate__fadeOutUp' },
        timer: 2500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    },

    formatDeliverers(data) {
      // Paruj JSON i formatuj jako ciąg znaków
      try {
        const names = JSON.parse(data.deliverers_short_names);
        return names.join(', ');
      } catch (e) {
        // Jeśli dane nie są poprawnym JSON-em, zwróć je bez zmian
        return data.deliverers_short_names;
      }
    },
  }
}
</script>

<style>
.not-editable {
  color: orangered;
}

#orderListGridId .colspan-footer {
  text-wrap: nowrap;
  align-items: center;
}

#orderListGridId .e-headercell,
#orderListGridId .e-rowcell {
  font-size: 12px;
}

.offcanvas-mobile {
  position: fixed;
  top: 0;
  left: 0;
  width: 320px;
  height: 100vh;
  background: #fff;
  z-index: 1050;
  transform: translateX(-100%);
  transition: transform 0.25s ease;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
}

.offcanvas-mobile.show {
  transform: translateX(0);
}


.e-checkbox-wrapper .e-frame.e-check {
  background-color: #ca6e1b !important;
  border-color: #ca6e1b !important;
}

.e-checkbox-wrapper .e-frame.e-check::before {
  color: #ffffff !important;
}


.e-grid .e-row.e-selectionbackground td {
  background-color: #d9d9d9 !important;
}

.e-grid .e-row.e-selectionbackground td.e-active {
  background-color: #d9d9d9 !important;
}

.e-grid .e-headercell .e-headercelldiv {
  padding-left: 5px !important;
  margin-left: 0 !important;
}

.e-grid .e-rowcell {
  padding-left: 5px !important;
}

#orderListGridId .clicked-row td {
  background-color: #d9d9d9 !important;
}

.project-select {
  width: 300px;
}

.project-select select {
  width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mobile-filter-panel {
  position: fixed;
  top: 0;
  left: 0;
  width: 320px;
  height: 100vh;
  background: #fff;
  z-index: 1060;
  transform: translateX(-100%);
  transition: 0.25s ease;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  padding: 16px;
}

.mobile-filter-panel.show {
  transform: translateX(0);
}
</style>